import { ChainID } from '@ankr.com/chains-list';

import { mapChainIdToPath } from 'modules/chains/utils/mapChainIdToPath';

const statsPathConfig: Partial<Record<ChainID, ChainID>> = {
  [ChainID.ALLORA_MAINNET_GRPC]: 'allora' as ChainID,
  [ChainID.ALLORA_TESTNET_GRPC]: 'allora-testnet' as ChainID,
  [ChainID.KAVA_TENDERMINT_GRPC]: 'kava-rpc' as ChainID,
  [ChainID.SEI_TENDERMINT_GRPC]: ChainID.SEI,
  [ChainID.SUI_GRPC]: ChainID.SUI,
  [ChainID.SUI_GRPC_ARCHIVE]: ChainID.SUI,
  [ChainID.SUI_TESTNET_GRPC]: ChainID.SUI_TESTNET,
  [ChainID.TAC_TENDERMINT_GRPC]: 'tac_tendermint' as ChainID,
  [ChainID.TAC_TESTNET_SPB_GRPC]: 'tac-spb-tendermint' as ChainID,
};

export const mapChainIDToStatsPath = (chainID: ChainID) => {
  return statsPathConfig[chainID] || mapChainIdToPath(chainID);
};
